import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import authService from '../../services/authService';

const AdminHeader = ({ adminUser }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const servicesDropdownRef = useRef(null);
  
  useEffect(() => {
    console.log('AdminHeader - Rendering with user:', adminUser);
  }, [adminUser]);
  
  useEffect(() => {
    // Close dropdown when clicking outside
    function handleClickOutside(event) {
      if (servicesDropdownRef.current && !servicesDropdownRef.current.contains(event.target)) {
        setServicesDropdownOpen(false);
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  // Early return AFTER all hooks
  if (!adminUser) {
    console.log('AdminHeader - No admin user data');
    return (
      <div className="admin-header" style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#ffdddd' }}>
        <p>Loading admin information...</p>
      </div>
    );
  }
  
  const isActive = (path) => {
    if (path === '/admin/services') {
      return location.pathname.startsWith('/admin/services');
    }
    if (path === '/admin/account') {
      // Account tab is active for both account and change-password routes
      return location.pathname === '/admin/account' || location.pathname === '/admin/change-password';
    }
    return location.pathname === path;
  };

  const handleLogout = () => {
    // Use authService to handle logout securely
    authService.adminLogout();
    navigate('/admin/login');
  };

  const tabStyle = {
    padding: '12px 20px',
    marginRight: '4px',
    textDecoration: 'none',
    display: 'inline-block',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px 8px 0 0',
    transition: 'all 0.2s',
    position: 'relative'
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: '#ffffff',
    color: '#4f46e5',
    borderLeft: '1px solid #e5e7eb',
    borderRight: '1px solid #e5e7eb',
    borderTop: '1px solid #e5e7eb',
    borderBottom: '1px solid #ffffff',
    marginBottom: '-1px',
    zIndex: 10
  };

  const inactiveTabStyle = {
    ...tabStyle,
    backgroundColor: 'transparent',
    color: '#6b7280',
    border: '1px solid transparent',
    marginBottom: '0'
  };

  return (
    <div className="admin-header" style={{ 
      marginBottom: '0', 
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '16px 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ 
            width: '32px', 
            height: '32px', 
            backgroundColor: '#4f46e5', 
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px'
          }}>
            <span style={{ color: 'white', fontWeight: 'bold', fontSize: '16px' }}>C</span>
          </div>
          <h1 style={{ 
            margin: '0', 
            fontSize: '1.5rem', 
            fontWeight: '600',
            color: '#111827'
          }}>CNXN Admin</h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {adminUser && (
            <>
              <div style={{ 
                marginRight: '20px', 
                textAlign: 'right',
                fontSize: '14px'
              }}>
                <div style={{ fontWeight: '600', color: '#111827' }}>
                  {adminUser.name || adminUser.email}
                </div>
                <div style={{ color: '#6b7280', textTransform: 'capitalize' }}>
                  {adminUser.role} Admin
                </div>
              </div>
              <button
                onClick={handleLogout}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#ef4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
              >
                Logout
              </button>
            </>
          )}
        </div>
      </div>
      
      <div style={{ 
        display: 'flex', 
        backgroundColor: '#f9fafb',
        padding: '0 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <Link 
          to="/" 
          style={isActive('/') ? activeTabStyle : inactiveTabStyle}
        >
          Dashboard
        </Link>
        <Link 
          to="/admin/organizations" 
          style={isActive('/admin/organizations') ? activeTabStyle : inactiveTabStyle}
        >
          Organizations
        </Link>
        <Link 
          to="/admin/users" 
          style={isActive('/admin/users') ? activeTabStyle : inactiveTabStyle}
        >
          Users
        </Link>
        <Link 
          to="/admin/partners" 
          style={isActive('/admin/partners') || location.pathname.startsWith('/admin/partners/') ? activeTabStyle : inactiveTabStyle}
        >
          Partners
        </Link>
        
        {/* Services Dropdown */}
        <div 
          ref={servicesDropdownRef}
          style={{ 
            position: 'relative',
            display: 'inline-block'
          }}
        >
          <div
            onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}
            style={{
              ...isActive('/admin/services') ? activeTabStyle : inactiveTabStyle,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            Services
            <span style={{ marginLeft: '5px', fontSize: '12px' }}>▼</span>
          </div>
          
          {servicesDropdownOpen && (
            <div style={{
              position: 'absolute',
              backgroundColor: '#fff',
              minWidth: '200px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              zIndex: 1,
              borderRadius: '8px',
              top: '100%',
              left: '0',
              border: '1px solid #e5e7eb',
              overflow: 'hidden'
            }}>
              <Link 
                to="/admin/services/points"
                style={{
                  padding: '12px 16px',
                  textDecoration: 'none',
                  display: 'block',
                  color: '#374151',
                  borderBottom: '1px solid #e5e7eb',
                  fontSize: '14px',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => setServicesDropdownOpen(false)}
                onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Points Management
              </Link>
              <Link 
                to="/admin/services/referral"
                style={{
                  padding: '12px 16px',
                  textDecoration: 'none',
                  display: 'block',
                  color: '#374151',
                  borderBottom: '1px solid #e5e7eb',
                  fontSize: '14px',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => setServicesDropdownOpen(false)}
                onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Referral Management
              </Link>
              <Link 
                to="/admin/services/redemption"
                style={{
                  padding: '12px 16px',
                  textDecoration: 'none',
                  display: 'block',
                  color: '#374151',
                  fontSize: '14px',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => setServicesDropdownOpen(false)}
                onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Redemption Management
              </Link>
            </div>
          )}
        </div>
        
        {/* Plugin tab - only for super admins */}
        {adminUser.role === 'super' && (
          <Link 
            to="/admin/plugin" 
            style={isActive('/admin/plugin') ? activeTabStyle : inactiveTabStyle}
          >
            Plugin
          </Link>
        )}
        
        <Link 
          to="/admin/account" 
          style={isActive('/admin/account') || location.pathname === '/admin/change-password' 
            ? activeTabStyle 
            : inactiveTabStyle}
        >
          Account
        </Link>
      </div>
    </div>
  );
};

export default AdminHeader;
